const ExpireDateStyle = ({ row }) => {
  const currentDate = new Date();
  const expireDate = new Date(row?.expireDate);
  const isExpired = !isNaN(expireDate.getTime()) && expireDate < currentDate;

  if (!row?.expireDate) {
    return <div></div>;
  }

  return (
    <div style={isExpired ? { color: "red", fontWeight: "bold" } : {}}>
      {row?.expireDate}
    </div>
  );
};

export default ExpireDateStyle;
